// extracted by css-extract-rspack-plugin
export default {"link":"Terms_link__R7p20"};